// extracted by mini-css-extract-plugin
export var contrastLow = "_41-1";
export var externalLink = "_41-2";
export var externalLinkIcon = "_41-3";
export var link = "_41-0";
export var linkLabel = "_41-4";